import PrivacyPolicy from '@/kyna/view/_public/PrivacyPolicy';
import BaseTemplate from '../src/layouts/BaseTemplate'

const Privacy_Policy = () => {
    return ( 
        <BaseTemplate title="Privacy Policy" body={<PrivacyPolicy />} />
     );
}
 
export default Privacy_Policy;